/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subrip_SrtInputs */



/**
* | output |
* | --- |
* | "SubRip (.srt)" |
*
* @param {Subrip_SrtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subrip_srt = /** @type {((inputs?: Subrip_SrtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subrip_SrtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("SubRip (.srt)")
	if (locale === "de") return /** @type {LocalizedString} */ ("SubRip (.srt)")
	if (locale === "it") return /** @type {LocalizedString} */ ("SubRip (.srt)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("SubRip (.srt)")
	if (locale === "es") return /** @type {LocalizedString} */ ("SubRip (.srt)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("SubRip (.srt)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブリップ (.srt)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सबरिप (.srt)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("SubRip (.srt)")
	return /** @type {LocalizedString} */ ("SubRip (.srt)")
});